import { Component, inject, signal } from "@angular/core";
import { MatToolbar } from "@angular/material/toolbar";
import { NgClass } from "@angular/common";
import { MatIcon } from "@angular/material/icon";
import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";

@Component({
	selector: "lib-page-footer",
	templateUrl: "./page-footer.component.html",
	styleUrls: ["./page-footer.component.scss"],
	imports: [MatToolbar, NgClass, MatIcon],
})
export class PageFooterComponent {
	config = inject<AppConfig>(APP_CONFIG_TOKEN);

	visible = signal(false);
	currentYear = new Date().getFullYear();

	toggle() {
		this.visible.update(visible => !visible);
	}
}
